<div class="mbp-table-wrap">
  <table
    mat-table
    matSort
    [dataSource]="items"
    class="mbp-data-table fulfilment-items-list"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="name-col">Name</th>
      <td mat-cell *matCellDef="let item" class="name-col">
        {{ item.orderItem.medicineDosagePackageType.label_name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="barcode">
      <th mat-header-cell *matHeaderCellDef>Barcode</th>
      <td mat-cell *matCellDef="let item" class="scan-cell">
        <mat-form-field appearance="outline" class="fulfilment-field">
          <mat-label>Barcode</mat-label>
          <input
            (focus)="focusBarcode(item)"
            (blur)="onBarcodeBlur(item)"
            required
            matInput
            id="{{ item.barcodeInputId }}"
            [formControl]="item.barcodeInput"
            placeholder="Barcode"
            title="Examples AMI001001, BOLT02523, ABC2345-003"
          />
          <button
            [color]="item.activated ? 'primary' : ''"
            title="Click to scan"
            matSuffix
            (click)="focusBarcode(item)"
            mat-icon-button
            type="button"
          >
            <mat-icon>
              {{
                item.focusedInput === FocusedInput.Barcode
                  ? 'radio_button_checked'
                  : 'radio_button_unchecked'
              }}
            </mat-icon>
          </button>
          @if (item.barcodeInput.invalid) {
            <mat-error>Barcode is not valid</mat-error>
          }
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="medicine_number">
      <th mat-header-cell *matHeaderCellDef>Medicine number</th>
      <td mat-cell *matCellDef="let item" class="scan-cell">
        <mat-form-field appearance="outline" class="fulfilment-field">
          <mat-label>Medicine number</mat-label>
          <input
            (focus)="focusMedicineNumber(item)"
            required
            matInput
            id="{{ item.medicineNumberInputId }}"
            [formControl]="item.medicineNumberInput"
            placeholder="Medicine number"
          />
          <button
            [color]="item.activated ? 'primary' : ''"
            title="Click to scan"
            matSuffix
            (click)="focusMedicineNumber(item)"
            mat-icon-button
            type="button"
          >
            <mat-icon>
              {{
                item.focusedInput === FocusedInput.MedicineNumber
                  ? 'radio_button_checked'
                  : 'radio_button_unchecked'
              }}
            </mat-icon>
          </button>
          @if (item.medicineNumberInput.invalid) {
            <mat-error>Medicine number is not valid</mat-error>
          }
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let item">
        {{ item.orderItem.status ? item.orderItem.status.status : '—' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="scanned">
      <th mat-header-cell *matHeaderCellDef>Scanned</th>
      <td mat-cell *matCellDef="let item" class="scanned-cell">
        <span class="scanned-cell__count">
          {{ item.scanned + ' / ' + item.orderItem.quantity }}
        </span>
        <mat-progress-bar
          [color]="item.errored ? 'warn' : 'primary'"
          mode="determinate"
          [value]="percentage(item)"
          class="scanned-cell__bar"
        >
        </mat-progress-bar>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef class="action-col">&nbsp;</th>
      <td mat-cell *matCellDef="let item" class="action-col">
        <button
          mat-flat-button
          color="primary"
          class="fulfilment-items-list__scan-btn"
          (click)="activateItem(item)"
        >
          Scan
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="details">
      <th mat-header-cell *matHeaderCellDef class="details-col">&nbsp;</th>
      <td mat-cell *matCellDef="let item" class="details-col">
        <button
          mat-stroked-button
          class="fulfilment-items-list__details-btn"
          (click)="openDetails(item.orderItem)"
        >
          <mat-icon>info</mat-icon> Details
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      [class.fulfilment-items-list__row--active]="row.activated"
      mat-row
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>
</div>
